import React from 'react';
import { Row, Column } from 'react-foundation';
import { Icon } from '../../components/Icon';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button'

interface Props {
	emptySims: any;
	sims: any[];
}

const CenterButton = styled.div`
  text-align: center;
  padding: 0;
`;

const Head = styled.h4`
  text-align: center;
  line-height: 125%;
`;

const Section = styled.div`
  margin: auto;
  text-align: center;
  margin-top: 2rem;
`;

export const SimsIndicator: React.FC<Props> = (props: Props) => {
	return (
		<Column large={6} small={12}>
			<Section>
				<Icon name="medium--sims" />
				<Head>{`${props.sims.length} ${props.sims.length === 1 ? 'liittymä' : 'liittymää'} on käytössä`}</Head>
				<p>{props.emptySims.toJS().length} {props.emptySims.toJS().length === 1 ? 'simmi' : 'simmiä'} on varastossa valmiina käyttöön</p>
				<Row>
					<Column className="large-centered columns">
						<CenterButton>
							<Link to={'/account/activateSubscription'} >
								<Button >Ota käyttöön uusi liittymä...</Button>
							</Link>
						</CenterButton>
						<CenterButton>
							<Link to={'/account/orderMore'}>
								<Button className="outlined">Tilaa lisää simmejä varastoon</Button>
							</Link>
						</CenterButton>
					</Column>
				</Row>
			</Section>
		</Column>
	);
};